
    import { computed, defineComponent, onBeforeMount, ref } from 'vue'
    import { pickBy } from 'lodash'

    import { useHeadful } from '@/common/composables/libs/headful'
    import { useI18n } from 'vue-i18n-composable'
    import type { Staff } from '@/common/models/data/dashboard/staff/staff'

    import StaffList from '@/app/components/common/staff/StaffList.vue'

    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useStaffStore } from '@/app/stores/staff'

    export default defineComponent({
        components: {
            StaffList
        },
        setup () {
            const headful = useHeadful()
            const i18n = useI18n()
            const staffStore = useStaffStore()

            const openedTab = ref(0)
            const staff = computed((): Record<string, Array<Staff>> => {
                return pickBy(staffStore.groupedStaff, (value: Array<Staff>, key: string): boolean => {
                    return key !== 'undefined'
                })
            })

            onBeforeMount(async (): Promise<void> => {
                useBreadcrumbsStore().set([
                    { text: i18n.t('nav.about.about').toString(), to: { name: 'about' } },
                    { text: i18n.t('nav.about.crew').toString() }
                ])

                headful({
                    title: `${i18n.t('nav.about.crew')} | ${i18n.t('meta.title')}`
                })

                await staffStore.loadStaff()
            })

            return {
                openedTab,
                staff
            }
        }
    })
